import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { initialLoadingScriptStoreState } from 'store/reducers/loadingScript/constants';
import { loadSQLScriptAction } from 'store/reducers/loadingScript/actions';
import { setSliceFn } from 'constants/store';
import { sourcesSlice } from 'store/reducers/sources';
import { PagesScriptInterface } from './types';
import { IdInterface } from 'types/store';

export const loadingScriptSlice = createSlice({
  name: 'loadingScript',
  initialState: initialLoadingScriptStoreState,
  reducers: {
    setSlice: setSliceFn,
    onAddPageSQLScript: (state, { payload }: PayloadAction<PagesScriptInterface>) => {
      state.pagesScript.push(payload);
    },
    onEditPageSQLScriptById: (state, { payload }: PayloadAction<PagesScriptInterface & IdInterface>) => {
      state.pagesScript = state.pagesScript.map((page) =>
        page.page === payload.id ? { page: payload.page, script: payload.script } : page,
      );
    },
    onDeletePageSQLScriptById: (state, { payload: { id } }: PayloadAction<IdInterface>) => {
      state.pagesScript = state.pagesScript.filter((page) => page.page !== id);
    },
    onSelectPageSQLScriptById: (state, { payload: { id } }: PayloadAction<IdInterface>) => {
      state.activePageScript = id;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(loadSQLScriptAction.pending, (state) => {
      state.SQLScript = '';
      state.pagesScript = [];
      state.activePageScript = '';
    });
    builder.addCase(loadSQLScriptAction.fulfilled, (state, { payload }) => {
      if (payload.pages.length) {
        state.activePageScript = payload.pages[0].page;
        state.SQLScript = payload.pages[0].script;
        state.pagesScript = payload.pages;
      }
    });
    builder.addCase(loadSQLScriptAction.rejected, (state) => {
      state.SQLScript = '';
      state.pagesScript = [];
      state.activePageScript = '';
    });
  },
});

export const { setSlice } = sourcesSlice.actions;
export const { onAddPageSQLScript, onEditPageSQLScriptById, onDeletePageSQLScriptById, onSelectPageSQLScriptById } =
  loadingScriptSlice.actions;

export default loadingScriptSlice.reducer;
